import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import MModal from '../../../common/m-modal/MModal';
import MInput from '../../../common/m-input/MInput';
import MCheckbox from '../../../common/m-checkbox/MCheckbox';
import MError from '../../../common/m-error/MError';

import { authRegex } from '../../../../models/auth';
import { useTranslation } from 'react-i18next';

import { setCredentials, setIsAuth } from '../../../../store/reducers/authSlice';
import { setActiveRole, setUser } from '../../../../store/reducers/userSlice';
import { useAuthUserMutation } from '../../../../api/AuthApi/authService';
import { useLazyGetUserViewQuery } from '../../../../api/UserApi/userService';
import { setIsError } from '../../../../store/reducers/notificationSlice';
import Cookies from 'universal-cookie';

function LoginModal({ isLoginModal, setIsLoginModal, setIsClicked, setIsChooseRoleModal }) {
    const dispatch = useDispatch();
    const [onAuthUser] = useAuthUserMutation();
    const [getUserData] = useLazyGetUserViewQuery();

    const cookies = new Cookies();

    const authUser = (role) => {
        dispatch(setUser({ activeRole: role, firstname: role }));
        setIsLoginModal(false);
        setIsClicked(false);
        dispatch(setIsAuth(true));
        setFormData({
            username: '',
            password: '',
            checkboxState: false
        });
    };

    const onHandleAuthButton = async (e) => {
        e.preventDefault();

        const { username, password } = formData;

        const errors = {};

        if (!password.trim()) {
            errors.password = 'password';
        } else if(!authRegex.password.test(password)){
            errors.other = 'wrongData';
        }

        if (!username.trim()) {
            errors.username = 'login';
        }

        if (Object.keys(errors).length > 0) {
            setErrors(errors);
        } else {
            const result = await onAuthUser({ username, password, grant_type: 'password' });
            if (result.error) {
                if(result.error.data?.error_code === 10100) {
                    setErrors(prev=>({...prev, other: 'wrongData'}))
                } else {
                    console.error(result.error);
                    dispatch(setIsError(result.error.message))
                    onModalClose()
                }
            } else {
                if(result.data.roles.filter(role => role === 'expert_teacher' || role === 'expert_student').length > 0) {
                    dispatch(setIsAuth(true));
                    dispatch(setCredentials(result.data.access_token));
                    cookies.set('jwt_auth', result.data.access_token, { httpOnly: true });
                    localStorage.setItem('jwt_refresh', JSON.stringify(result.data.refresh_token))
                    const userData = await getUserData({ username, role: result.data.roles[0] });
                    if (userData.error) {
                        console.error(userData.error);
                    } else {
                        const user = { ...userData.data.user };
                        localStorage.setItem('user',JSON.stringify({...user, activeRole: user.roles[0]}))
                        dispatch(setUser(user));
                        dispatch(setActiveRole(user.roles[0]))
                        if(user.roles.length>1) {
                            setIsChooseRoleModal(true)
                        }
                    }
                }
                onModalClose()
            }
        }
    };

    const onModalClose = () => {
        setIsLoginModal(false);
        setIsClicked(false);
        setFormData({
            username: '',
            password: '',
            checkboxState: false
        });
        setErrors({});
    }

    const [formData, setFormData] = useState({
        username: '',
        password: '',
        checkboxState: false
    });
    const [errors, setErrors] = useState({});

    const { t } = useTranslation();

    const onHandleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData, [name]: value
        });
    };

    return (
        <MModal
            className="w-[410px]"
            active={isLoginModal}
            setActive={setIsLoginModal}
            onCloseModal={() => {
                setFormData({
                    username: '',
                    password: '',
                    checkboxState: false
                });
                setErrors({});
            }}
        >
            <form
                onSubmit={onHandleAuthButton}
            >
                <div className="flex flex-col">
                    <h5 className="text-xl font-bold mx-auto my-3">{t('general.header.loginModal.title')}</h5>

                    <MInput
                        placeholder={t('general.header.loginModal.loginPlaceholder')}
                        value={formData.username}
                        setValue={onHandleChange}
                        name="username"
                        error={errors.username}
                    />

                    {errors.username && <MError text={errors.username}/>}

                    <MInput
                        placeholder={t('general.header.loginModal.passPlaceholder')}
                        type="password"
                        value={formData.password}
                        setValue={onHandleChange}
                        name="password"
                        error={errors.password}
                    />

                    {errors.password && <MError text={errors.password}/>}

                    <MCheckbox
                        label={t('general.header.loginModal.rememberMe')}
                        value={formData.checkboxState}
                        setValue={() => setFormData(({
                            ...formData,
                            checkboxState: !formData.checkboxState
                        }))}
                    />

                    <button
                        className="btn-primary my-2"
                        type="submit"
                    >
                        {t('general.header.loginModal.enter')}
                    </button>
                </div>
            </form>
        </MModal>
    );
}

export default LoginModal;
